import constants_default from '^/components/global/constants';

export default {
  ...constants_default,
  // show or hide the aside on the right product information of the product detail page
  IS_SHOW_PRODUCT_DETAIL_RIGHT_SIDEBAR: false,
}



// WEBPACK FOOTER //
// ./ixcms/themes/jedco/src/vue-src/components/global/constants.js